import { NgModule, ErrorHandler, CUSTOM_ELEMENTS_SCHEMA, CSP_NONCE } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { UtilsService } from './shared/services/utils/utils.service';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SessionMgmtService } from './shared/services/session-mgmt/session-mgmt.service';
import { httpInterceptorProviders } from './interceptors/interceptor-index';
import { ToastService } from './shared/services/toast/toast.service';
import { NgToastModule } from 'ng-angular-popup';
import { CommonModule } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';
import { UserActivitiesService } from './shared/services/user-activities/user-activities.service';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha-2';

import { ActionService } from './shared/services/action/action.service';

import { environment } from 'src/environments/environment';
import { getCspNonce } from './shared/utils/csp-nonce.util';
import { PageNotFoundComponent } from './features/page-not-found/page-not-found.component';
import { NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule } from 'ngx-google-analytics';
import { RouterModule } from '@angular/router';
import { AccountsModule } from './features/accounts/accounts.module';
import { ProjectsModule } from './features/projects/projects.module';
import { BannerHandler } from './shared/services/banner/banner-handler';

import { LtmsDownloadWidgetComponent } from './shared/components/ltms-download-widget/ltms-download-widget.component';
import { LitmusComponentsModule } from './litmus-components/litmus-components.module';

import { LitmusComponentsService } from './litmus-components/litmus-components.service';
import { LitmusAlertComponent } from './shared/components/litmus-alert/litmus-alert.component';

import { LtmsToastComponent } from './shared/components/ltms-toast/ltms-toast.component';
import { SharedModule } from './shared/components/shared.module';
import { provideQuillConfig } from 'ngx-quill/config';
declare global {
  interface String {
    capitalizeFirstLetter(): string;
    calculateNumeric(): number;
  }
}

const cspNonce = getCspNonce();

@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    LitmusAlertComponent,
    LtmsToastComponent
  ],
  bootstrap: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    SharedModule,
    RecaptchaV3Module,
    ReactiveFormsModule,
    ProjectsModule,
    AccountsModule,
    NgToastModule,
    DragDropModule,
    LitmusComponentsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    NgbModule,
    NgxGoogleAnalyticsModule.forRoot(environment.google_analytics_4.measurement_id),
    NgxGoogleAnalyticsRouterModule,
    BrowserAnimationsModule,
    CommonModule,
    ToastrModule.forRoot(),
    AppRoutingModule,
  ],
  providers: [
    UtilsService,
    SessionMgmtService,
    ToastService,
    ActionService,
    UserActivitiesService,
    httpInterceptorProviders,
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.google_recaptcha_v3.sitekey,
    },
    ...(cspNonce ? [{ provide: CSP_NONCE, useValue: cspNonce }] : []),
     provideHttpClient(withInterceptorsFromDi())
  ],
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})

export class AppModule {
  constructor(private litmusComponents: LitmusComponentsService, private _utilsService: UtilsService) {
    this._utilsService.initializePGP();
    String.prototype.capitalizeFirstLetter = function(): string {
      try {
          return this.replace(/\w\S*/g, function(txt) {
              return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
          });
      } catch (e) {
          return this.toString();
      }
    }
    
    String.prototype.calculateNumeric = function() {
      var totalStringValue = 0;
      for (var i = 0; i < this.length; i++) {
          totalStringValue += this.charCodeAt(i);
      }
      return totalStringValue;
    }
    litmusComponents.registerComponents();
  }
 }

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  if (environment && environment['isDocker'] && environment['isDocker'] == true) {
    const baseElement = document.querySelector('base');
      if (baseElement) {
        console.log("routed to /v3/")
        baseElement.setAttribute('href', '/v3/');
      }
    return new TranslateHttpLoader(http, '/v3/assets/i18n/', '.json');
  } else {
    return new TranslateHttpLoader(http);
  }
}
